 <app-table-title [fontSize]="'24px'" [title]="(differentLoggedIn ? label : ('MY' | dictionary)) + ' ' + ('DOCUMENTS' | dictionary)"></app-table-title>
 <div class="m-portlet m-portlet--unair">
   <div class="m-portlet__body" style="min-height: 324px;">
     <div class="table-responsive">
       <!-- Statements  -->
       <div style="margin-bottom: 0;" *ngIf="statements && statements.length > 0">
         <div class="text-color-deep-heading subheader">
           {{statementsTitle | dictionary}}
         </div>

         <div *ngFor="let s of statements" class="item-row cursor-pointer" (click)="Download(s.seqNum,s.FileNum,s.AppendSeqNum)">
           <i class="fas fa-file-alt icon"></i>
           <span class="text-color-black form-label">{{s.Label}}</span>
         </div>
       </div>
       <div class="col-lg-12 more-wrapper" *ngIf="statements && statements.length > 0">
                         <span class="float-right"><a
                           [routerLink]="[statementsLink]">...{{'MORE' | dictionary}}</a></span>
       </div>
       <!-- Tax  -->
       <div style="margin-bottom: 0;" *ngIf="taxes && taxes.length>0">
         <div class="text-color-deep-heading subheader">
           {{'TAX_DOCUMENTS' | dictionary}}
         </div>

         <div *ngFor="let tax of taxes" class="item-row cursor-pointer"
              (click)="checkTaxTypeDownload(tax)">
           <i class="fas fa-file-alt icon"></i>
           <span class="text-color-black form-label">{{tax.Label}}</span>
         </div>

       </div>
       <div class="col-lg-12  more-wrapper" *ngIf="taxes && taxes.length>0">
                         <span class="float-right"><a
                           [routerLink]="['/tax']">...{{'MORE' | dictionary}}</a></span>
       </div>

       <!--Communications   -->
       <div style="margin-bottom: 0;" *ngIf="communications && communications.length>0">
         <div class="text-color-deep-heading subheader">
           {{'COMMUNICATION' | dictionary}}
         </div>

         <div *ngFor="let communication of communications" class="item-row cursor-pointer"
              (click)="Download(communication.seqNum,communication.FileNum,0)">
           <i class="fas fa-file-alt icon"></i>
           <span class="text-color-black form-label">{{communication.Label}}</span>
         </div>

       </div>
       <div class="col-lg-12  more-wrapper" *ngIf="communications?.length">
                         <span class="float-right"><a
                           [routerLink]="['/inbox']">...{{'MORE' | dictionary}}</a></span>
       </div>

       <!--Confirms   -->
       <div style="margin-bottom: 0;" *ngIf="confirms && confirms.length>0">
         <div class="text-color-deep-heading"
              style="width: 150px; border-top:0px; font-size: 18px; padding-left:0px;padding-bottom: 2px;">
           {{'CONFIRMS' | dictionary}}
         </div>

         <div *ngFor="let c of confirms" class="item-row cursor-pointer"
              (click)="DownloadTaxOrConfirms(c.seqNum,c.FileNum)">
           <i class="fas fa-file-alt icon"></i>
           <span class="text-color-black form-label">{{c.Label}}</span>
         </div>

       </div>
       <div class="col-lg-12 more-wrapper" *ngIf="confirms && confirms.length>0">
                         <span class="float-right"><a href="javascript:void(0);"
                                                                              (click)="navigateToConfirmMsg()"></a></span>
       </div>
     </div>
   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>
